import useAssetTransactionSlides from 'hooks/use-asset-transaction-slideup/useAssetTransactionSlides';
import { useDispatch, useSelector } from 'react-redux';
import { toggleModalState } from 'service/sliding-pane/action';
import { selectAssetModalState } from 'service/sliding-pane/selectors';
import AssetViewModel from 'view-model/Assets/AssetViewModel';
import IUseAssetSlideView from './IUseAssetSlideView';

const useAssetSlideView = (): IUseAssetSlideView => {
    const { closeAssetTransaction } = useAssetTransactionSlides();
    const dispatch = useDispatch();
    const { isOpen, slugParam, isSlidingUp, overlaySlug } = useSelector(selectAssetModalState)

    const onAssetProfileClick = ({ AssetId, AssetSlug }: AssetViewModel, callbackFxn?: () => void) => {
        // Redirection for Modric
        if (AssetId === "68e8f1115912da79b6184929") {
            const externalUrl = "https://app.trendex.gg/";
            return window.location.replace(externalUrl);
        }

        // Comportement normal pour les autres assets
        if (!isOpen) {
            dispatch(toggleModalState({ isOpen: true, slugParam: AssetSlug, isSlidingUp: true }));
        }
        else if (slugParam) {
            dispatch(toggleModalState({ overlaySlug: AssetSlug, isSlidingUp: true }));
        }
        if (callbackFxn) callbackFxn();
    }

    const onSlideViewOpen = () => {
        if (overlaySlug) {
            dispatch(toggleModalState({ isSlidingUp: false, slugParam: overlaySlug, overlaySlug: '' }))
            return;
        }
        dispatch(toggleModalState({ isSlidingUp: false }))
    }

    const onSlideViewClose = () => {
        closeAssetTransaction();
        dispatch(toggleModalState({ isOpen: false }))
    }

    const onTransitionComplete = () => {
        dispatch(toggleModalState({ isOpen: false, slugParam: '', overlaySlug: '', isSlidingUp: false }));
    }

    return {
        activeSlug: slugParam,
        isSlideViewOpen: isOpen,
        overlaySlug,
        isSlidingUp,
        onAssetProfileClick,
        onSlideViewClose,
        onSlideViewOpen,
        onTransitionComplete
    };
};

export default useAssetSlideView;
